import { useLayoutEffect } from "react";
import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import { SwiperSlide } from "swiper/react";

import ButtonNew from "components/atoms/ButtonNew";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import PostSlider from "components/organisms/PostSlider";
import RequiredDocument from "components/organisms/RequiredDocument";
import StepSlider from "components/organisms/StepSlider";
import SupportedCountries from "components/organisms/SupportedCountries";
import { Wave } from "components/organisms/Wave";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";

import OurPricing from "./OurPricing";
import VideoPlayer from "./VideoPlayer";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

/** ========== */

const OffshoreCompanyFormation = ({ data, dataJson }) => {
  useLayoutEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const id = window.location.hash.replace("#", "");
        const scrollToTable = document
          .getElementById(id)
          .getBoundingClientRect();

        window.scrollTo({
          top: scrollToTable.top + window.pageYOffset - 86,
          behavior: "smooth",
        });
      }, 100);
    }
  }, []);

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson?.breadcrumbs}
        title="Offshore Company Formation"
        titleProps={{
          className: "banner-default-title mb-10",
          textColor: "banner-title-gradient-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src="/assets/images/offshore/company-formation/banner-offshore-formation.png"
            wrapper={{
              className: "bbc-banner-image-country pb-8 lg:pb-0",
            }}
            className="h-full w-full"
            width={650}
            height={480}
            alt="offshore company formation with the help of technology"
          />
        }
        bgColor="bg-bbc-gradient-service"
        dataTrustpilot={{
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot,
        }}
      ></Banner>
      <section className="mt-10 lg:mt-20">
        <div className="container">
          <div className="col-10 m-auto ">
            <Title className="title-h2 mb-4 text-center  text-bbc-brand-800 lg:mb-10 ">
              Quick Offshore Company Formation With Client Portal
            </Title>
          </div>
          <div className="row flex-col-reverse items-center lg:flex-row">
            <div className="col-12 lg:col-6  ">
              <p>Setting up an international business company can be tough. </p>
              <br />
              <p>
                You&apos;re forced to brave through layers of complex local laws
                and corporate governance guidelines only to struggle to stay on
                top of it all in the end.
              </p>
              <br />
              <p>
                But what if there&apos;s another way to approach this? One that
                allows you to
              </p>
              <ul className="list-disc pt-4	pl-6">
                <li className="pb-2">Fast-track your formation process</li>
                <li className="pb-2">
                  Be in control of all compliance related matters
                </li>
                <li className="pb-2">Stay on top of any law changes</li>
              </ul>
              <p>This is where we come in.</p>
            </div>
            <div className="col-12 mb-6 lg:col-6 lg:mb-0">
              <div className="h-full">
                {/* <LazyLoad>
                  <iframe
                    src="https://www.youtube.com/embed/8RkJwKEXKPU?start=32"
                    width="540"
                    height="303"
                    frameBorder="0"
                    title="BBCIncorp Client Portal - Bring your next business venture online"
                    allow="accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture"
                    allowFullScreen
                    className=" w-full"
                  ></iframe>
                </LazyLoad> */}
                <VideoPlayer />
              </div>
            </div>
          </div>
        </div>
      </section>
      <SupportedCountries
        id="company-registration"
        title="Company Registration Worldwide"
        description="Set up your business in over +15 countries and receive consultations from our local experts."
        data={dataJson.supportedCountries}
        descriptionBottom={
          <div className="text-center text-bbc-white ">
            Not sure where to go offshore ?
            <a
              onClick={async () => {
                // eslint-disable-next-line no-undef
                await Tawk_API.toggle();
              }}
              className="ml-2 inline-block cursor-pointer"
            >
              <span className="  text-bbc-secondary-300 ">
                Talk to our experts
              </span>
            </a>
          </div>
        }
      />
      <section>
        <div className="container">
          <PostSlider
            thetitle="Typical use of an offshore company"
            description="An offshore company can be flexible with various business industries."
            showPaginationClass="lg:visible lg:pt-4"
            pagination={{
              el: ".bbc-slide-pagination",
              clickable: true,
              bulletClass: "bbc-pagination-bullet",
              bulletActiveClass: "bg-bbc-brand-700 opacity-100",
            }}
          >
            {Array.isArray(dataJson?.dataOffshoreSlider) &&
              dataJson?.dataOffshoreSlider.length > 0 &&
              dataJson?.dataOffshoreSlider.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="!h-auto py-6">
                    <div className=" h-full w-full rounded-3xl bg-white shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                      <div className="mb-4 pt-6">
                        <Img
                          src={item.img_src}
                          alt="a"
                          wrapper={{ className: "w-full" }}
                          className="m-auto aspect-[16/9] h-20 w-20 rounded-t-3xl object-cover"
                        />
                      </div>
                      <div className="px-6 pb-8">
                        <Title
                          as="h3"
                          className="text-center text-lg font-semibold text-bbc-brand-700 line-clamp-2"
                        >
                          {item?.title}
                        </Title>
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </PostSlider>
          <p className=" text-center lg:pt-6">
            Need more resources?{" "}
            <ButtonNew
              as="a"
              className="font-medium text-bbc-brand-500"
              target="_blank"
              useRouter
              href="/guide-and-tool/offshore-company-comparison"
            >
              This page{" "}
            </ButtonNew>
            helps you out.
          </p>
        </div>
      </section>

      <Wave
        background="lg:bg-bbc-brand-100"
        srcTop="/assets/images/offshore/company-formation/w1-offshore-formation.svg"
        srcBottom="/assets/images/offshore/company-formation/w2-offshore-formation.svg"
        heightBottom=" h-4/5 "
        sectionTop={
          <div className="m-auto lg:col-10">
            <FormCountries
              title="Wonder how an offshore company fits your plan?"
              descriptionClass="mb-6 lg:mb-10 text-center"
              contentBottom={
                <div className="row mt-10">
                  <div className="col-12 text-center">
                    <div className="justify-center lg:flex">
                      <span className="border-r border-bbc-gray pr-4 ">
                        Non-Obligatory Consultation
                      </span>
                      <p className="lg:pl-4 ">Highly Responsive Reps</p>
                    </div>
                  </div>
                </div>
              }
              description="Just leave your questions here, and we will get back within 2 hrs."
            />
          </div>
        }
        sectionBottom={
          <div className=" container" id="PriceTable">
            <Title
              as="h2"
              className="mb-6 text-center text-3xl font-semibold  capitalize text-bbc-brand-800 lg:text-bbc-40px"
            >
              Our pricing
            </Title>
            <OurPricing />
          </div>
        }
      >
        <div className="py-10 lg:py-20">
          {dataJson.dataRegistrationStep &&
            typeof dataJson.dataRegistrationStep === "object" &&
            Object.keys(dataJson.dataRegistrationStep).length > 0 && (
              <StepSlider
                data={dataJson.dataRegistrationStep}
                className="mx-auto pt-0 lg:pt-0"
                title={dataJson.dataRegistrationStep.title}
                description={dataJson.dataRegistrationStep.description}
                imgAlt={dataJson.dataRegistrationStep.alt}
              />
            )}
        </div>
        <div className="pb-10 lg:pb-20">
          <WhatMakeUsDifferent
            title="Bring your next business venture online"
            data={dataJson.dataWhatMakeUsDifferent}
            className="bg-wmud py-[60px] capitalize"
          />
        </div>
      </Wave>
      <div className="pb-10 lg:pb-20">
        <div className="container ">
          <div className="row ">
            <div className="col-12 ">
              <Title
                as="h2"
                className="mb-6 text-center text-3xl font-semibold  capitalize text-bbc-brand-800 lg:text-bbc-40px"
              >
                How it works with BBCIncorp
              </Title>
              <p className="col-12 m-auto text-center lg:col-9">
                From making incorporation decisions, creating order to managing
                incorporation process, we add value along your incorporation
                journey.
              </p>
            </div>
            {dataJson.dataHowItWorks?.length > 0 &&
              dataJson.dataHowItWorks?.map((item, index) => (
                <div className={"col-12 mt-6 lg:col-4 lg:mt-10"} key={index}>
                  <div
                    className="mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500 lg:mb-10"
                    style={{
                      width: "58px",
                      height: "58px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {index + 1}
                  </div>
                  {item?.title && (
                    <Title
                      as="h3"
                      className="mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold"
                    >
                      {item.title}
                    </Title>
                  )}
                  <p className="text-bbc-gray">{item.content}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
      <section>
        <RequiredDocument
          title="Required Documents"
          data={dataJson.dataRequiredDocument}
          backgroundImage="/assets/images/common/required-documents.png"
          sectionClassName="py-10 lg:py-20 "
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              // Description="Get your answers from commonly asked questions."
              title="Frequently Asked Questions"
              data={dataJson.dataFaqs}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default OffshoreCompanyFormation;
